import { memo } from 'react';
import { formatSource, type SectorIntelItem } from './sectorIntel.types';

interface Props {
  items: SectorIntelItem[];
  isLoading?: boolean;
}

export function SectorIntelTable({ items, isLoading }: Props): JSX.Element {
  return (
    <div className="pca-table-wrap">
      <div style={{ maxHeight: '65vh', overflowY: 'auto' }}>
        <table className="pca-table" data-testid="sector-intel-table">
          <thead>
            <tr>
              <th style={{ width: 110 }}>섹터 유형</th>
              <th>섹터명</th>
              <th style={{ width: 180 }}>Canonical ID</th>
              <th style={{ width: 160 }}>최종 섹터</th>
              <th style={{ width: 140 }}>소스</th>
              <th style={{ width: 90 }}>심볼</th>
              <th>종목명</th>
              <th style={{ width: 110 }}>편입일</th>
              <th style={{ width: 110 }}>제외일</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={9} className="pca-empty">
                  불러오는 중…
                </td>
              </tr>
            )}
            {!isLoading && items.length === 0 && (
              <tr>
                <td colSpan={9} className="pca-empty">
                  조건에 맞는 섹터 매핑이 없습니다.
                </td>
              </tr>
            )}
            {items.map((it) => (
              <SectorIntelRow
                key={`${it.symbol}-${it.sectorType}-${it.sectorName}-${it.validFrom}-${it.source}`}
                item={it}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const SectorIntelRow = memo(function SectorIntelRow({
  item,
}: {
  item: SectorIntelItem;
}): JSX.Element {
  return (
    <tr>
      <td>
        <span className={`pca-status-badge si-badge--${item.sectorType.toLowerCase()}`}>
          {item.sectorType}
        </span>
      </td>
      <td>{item.sectorName}</td>
      <td>
        {item.canonicalSectorId ? (
          <code>{item.canonicalSectorId}</code>
        ) : (
          <span className="pca-muted">—</span>
        )}
      </td>
      <td>
        {item.canonicalDisplayName ?? <span className="pca-muted">—</span>}
      </td>
      <td>{formatSource(item.source)}</td>
      <td>
        <strong>{item.symbol}</strong>
      </td>
      <td>{item.stockName ?? '—'}</td>
      <td>{item.validFrom}</td>
      <td>{item.validTo ?? <span className="pca-muted">진행중</span>}</td>
    </tr>
  );
});
